import { useClearThresholdAlertMutation, useClearThresholdHistoryBulkMutation } from "../../../../store/api/devices/deviceApiSlice";
import { useStoreDispatch } from "../../../../store/hooks";
import { setOpenToast } from "../../../../store/helpers/helperReducers";
import { errorMessage } from "../../../../utils/helpers";

export const useClearKpiAlertThreshold = () => {
  const [clearSingleRequest, singleState] = useClearThresholdAlertMutation();
  const [clearBulkRequest, bulkState] = useClearThresholdHistoryBulkMutation();
  const dispatch = useStoreDispatch();
  const isLoading = singleState.isLoading || bulkState.isLoading;

  const clearSingle = async (id: number) => {
    try {
      await clearSingleRequest(id).unwrap();
      dispatch(setOpenToast({ openToast: true, toastType: "success", message: "Cleared successfully" }));
      return true;
    } catch (err) {
      const msg = errorMessage(err);
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: msg }));
      return false;
    }
  };

  const clearBulk = async (ids: number[]) => {
    if (!ids.length) {
      return false;
    }
    try {
      await clearBulkRequest({ ids }).unwrap();
      dispatch(setOpenToast({ openToast: true, toastType: "success", message: "Cleared successfully" }));
      return true;
    } catch (err) {
      const msg = errorMessage(err);
      dispatch(setOpenToast({ openToast: true, toastType: "error", message: msg }));
      return false;
    }
  };

  return { clearSingle, clearBulk, isLoading };
};
